import classnames from 'classnames';
import Analytics from '@/analyticsGA';
import { Chip } from '@scramble/ui';
import { prettyMoney } from '@scramble/utils';
import s from './index.module.scss';

const AMOUNT_PRESETS = [50, 100, 300, 500, 1000];

export const AmountPresets = ({ value, className, onClick }) => {
  return (
    <div className={classnames(s.presets, className)}>
      {AMOUNT_PRESETS.map(amount => (
        <Chip
          size="medium"
          key={amount}
          selected={Number(value) === amount}
          onClick={() => {
            Analytics.addCashAmount('Amount change (presets)');
            onClick(amount);
          }}
        >
          {prettyMoney(amount, { decimalPlaces: 0 })}
        </Chip>
      ))}
    </div>
  );
};
